import { useQuery } from '@tanstack/react-query';
import { boatApi } from '../services/boatApi';

// Canonical engine manufacturers (category = engine).
export function useEngineManufacturerOptions() {
  return useQuery({
    queryKey: ['inventory', 'engine-manufacturer-options'],
    queryFn: () => boatApi.getFieldOptions('engine_manufacturer'),
    staleTime: 5 * 60_000,
  });
}
